import React from 'react';
import { Send, ArrowRight } from 'lucide-react';
import { Button, Card } from './Primitives';
import { TELEGRAM_CHANNEL_URL } from '../../data/constants';

export default function TelegramCommunityCard({
  title = 'Join our Telegram community',
  description = 'Connect with a fast-growing educational and interactive community for market updates, crypto learning, and direct conversation with other members.',
  compact = false,
}) {
  return (
    <Card
      className="telegram-community-card"
      style={{
        padding: compact ? '1.35rem' : '1.6rem',
        background: 'linear-gradient(135deg, rgba(143, 59, 46, 0.08) 0%, rgba(255, 255, 255, 0.96) 48%, rgba(244, 235, 226, 0.98) 100%)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '-42px',
          right: '-18px',
          width: '140px',
          height: '140px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(143, 59, 46, 0.18) 0%, transparent 68%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: compact ? '14px' : '18px' }}>
        <div className="telegram-community-head" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              width: compact ? '44px' : '52px',
              height: compact ? '44px' : '52px',
              borderRadius: '16px',
              background: 'linear-gradient(135deg, var(--clr-accent) 0%, var(--clr-accent-2) 100%)',
              color: 'var(--clr-on-accent)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 14px 30px rgba(143, 59, 46, 0.18)',
              flexShrink: 0,
            }}
          >
            <Send size={compact ? 18 : 22} />
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--clr-accent)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
              Telegram Channel
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: compact ? '1.15rem' : '1.4rem', fontWeight: 800, color: 'var(--clr-text)', lineHeight: 1.15 }}>
              {title}
            </div>
          </div>
        </div>

        <p style={{ fontSize: compact ? '13px' : '14px', color: 'var(--clr-text-2)', lineHeight: 1.75, maxWidth: compact ? '100%' : '760px' }}>
          {description}
        </p>

        <div className="telegram-community-actions" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <Button
            className="telegram-community-button"
            variant="primary"
            size={compact ? 'md' : 'lg'}
            onClick={() => window.open(TELEGRAM_CHANNEL_URL, '_blank', 'noopener,noreferrer')}
          >
            Join Telegram <ArrowRight size={16} />
          </Button>
          <div style={{ fontSize: '12px', color: 'var(--clr-text-3)' }}>
            Educational updates, market talk, and interactive community support.
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .telegram-community-card {
            padding: 1.1rem !important;
          }

          .telegram-community-head {
            align-items: flex-start !important;
          }

          .telegram-community-actions {
            align-items: stretch !important;
          }

          .telegram-community-button {
            width: 100%;
          }
        }
      `}</style>
    </Card>
  );
}
